import HubspotCTA from '@/components/ui/hubspot-cta'
import CtaLink, { buttonStyles, SizeType } from '@/components/ui/cta-link'
import LogoHorizontal from '@/icons/logo-horizontal.svg'
import { TypeComponentCtaLink, TypeComponentHubspotCta } from '@/types/ctf'
import SafeHTML from '@/components/ui/safe-html'

import City from '../graphics/city'
import Laptop from '../graphics/laptop'
// import FluidModalButton from '../components/fluid-modal-button'

export type HeroProps = {
  heading: string
  description: string
  hubspotCta: TypeComponentHubspotCta<'WITHOUT_UNRESOLVABLE_LINKS'>
  ctaLink: TypeComponentCtaLink<'WITHOUT_UNRESOLVABLE_LINKS'>
  ctaUrl?: string
  ctaLabel?: string
  ctaStyle?: string
}

export default function Hero({ heading, description, hubspotCta, ctaLink, ctaUrl, ctaLabel, ctaStyle }: HeroProps) {
  const {
    fields: { label, size, ...hubspotCtaProps },
  } = hubspotCta || ({ fields: {} } as HeroProps['hubspotCta'])

  const ctaLinkUrl = ctaUrl || ctaLink?.fields.link?.fields?.url
  const ctaLinkLabel = ctaLabel || ctaLink?.fields.label
  const ctaLinkStyle = ctaStyle || ctaLink?.fields.style || buttonStyles.btnSolid

  return (
    <section className="relative z-1 mb-24 pl-8 lg:min-h-[80vh] lg:pl-20 lg:flex-row">
      <div className="relative max-w-(--breakpoint-2xl) mx-auto flex flex-col-reverse items-center justify-stretch lg:flex-row">
        <div className="flex-1 mt-[72px] pr-8 z-10 lg:mt-24 lg:mb-48 lg:pr-0">
          <LogoHorizontal className="w-[200px] text-primaryBlue dark:text-white" />
          <h1 className="mt-8">{heading}</h1>
          <SafeHTML className="text-base md:text-lg" html={description} as="p" />
          <div className="2xl:flex flex-row gap-4">
            <div className="mt-2 mb-4 2xl:mb-0">
              {hubspotCta && (
                <HubspotCTA {...hubspotCtaProps} size={size as SizeType}>
                  {label}
                </HubspotCTA>
              )}
              {ctaUrl && (
                <CtaLink to={ctaLinkUrl} style={ctaLinkStyle}>
                  {ctaLinkLabel}
                </CtaLink>
              )}
            </div>
          </div>
          {/* <CtaLink to="/ebook/security-in-the-age-of-ai" variant={buttonStyles.btnSolid}>
            Download the eBook
          </CtaLink> */}
          {/* <FluidModalButton buttonText={downloadButton} /> */}
        </div>
        <div className="h-1/2 w-full md:h-[50vh] lg:flex-2 lg:h-[90vh] pointer-events-none">
          <Laptop />
        </div>
        <City />
      </div>
    </section>
  )
}
